import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ACTIVITIES_ROUTES } from 'components/routes';
import { useAuth } from 'modules/auth/context/AuthContextV2';
import PrivateRoute from './PrivateRoute';

const ActivitiesRoutes: React.FC = () => {
  const { isAuthenticated } = useAuth() ?? false;

  return (
    <>
      <Routes>
        {ACTIVITIES_ROUTES.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                {route.element}
              </PrivateRoute>
            }
          />
        ))}
      </Routes>
    </>
  );
};

export default ActivitiesRoutes;
